import * as React from "react";
import {
  container,
  scroll,
  scrollHidden,
  bookMoreRooms,
} from "./GlobalOccupancy.module.scss";
import { IBookMoreRoomsMessage } from "./GlobalOccupancyProps";

export const Container: React.FC<any> = (props) => {
  return (
    <div
      className={`${container} p-3  ${
        props.showScroll ? scroll : scrollHidden
      }`}
    >
      {props.children}
    </div>
  );
};

export const BookMoreRoomsMessage = (props: IBookMoreRoomsMessage) => {
  return (
    <div className={bookMoreRooms}>
      {props.isReservationCart
        ? `To book more than three rooms in a single reservation, please contact us at 833-580-2410.`
        : `To book more than 3 rooms in a single reservation, please contact us at
      833-580-2410.`}
    </div>
  );
};
